export default "__VITE_ASSET__BTwAti9W__"